import { MergeField, MergeSchema, getSchema } from '../../decorators';
import { ActivityEntityName } from '../../../../entities';

@MergeSchema()
export class LeadContactMergeData {

    @MergeField()
    firstName: string;

    @MergeField()
    lastName: string;

    @MergeField()
    name: string;

    @MergeField()
    email: string;

    @MergeField()
    mobile: string;

    @MergeField()
    workPhone: string;

    @MergeField()
    jobTitle: string;
}

export const LeadContactMergeSchema = getSchema(LeadContactMergeData);